export default __webpack_public_path__ + "static/media/duo.008891b4.png";